import { api } from "~/infrastructure/api";

export type OnboardingCustomerParams = {
  companyName: string;
  tradingName: string;
  email: string;
  phone: string;
  cnpj: string;
  averageTravelSpend?: number | null;
  referredBy?: string | null;
};

export type OnboardingCustomerResult = {
  message: string;
  resetPasswordToken: string;
  resetPasswordUrl: string;
  customerUuid: string;
};

type OnboardingCustomerDTO = {
  message: string;
  reset_password_token: string;
  reset_password_url: string;
  customer_uuid: string;
};

export class SignUpService {
  async onboardCustomer(
    agencyUuid: string,
    data: OnboardingCustomerParams,
  ): Promise<OnboardingCustomerResult> {
    return await api
      .post<OnboardingCustomerDTO>(`/agencies/${agencyUuid}/onboarding-customers`, {
        company_name: data.companyName,
        trading_name: data.tradingName,
        email: data.email,
        phone: data.phone.replace(/\D/g, ""),
        cnpj: data.cnpj.replace(/\D/g, ""),
        average_travel_spend: data.averageTravelSpend ?? null,
        referred_by: data.referredBy ?? null,
      })
      .then(({ data }) => ({
        message: data.message,
        resetPasswordToken: data.reset_password_token,
        resetPasswordUrl: data.reset_password_url,
        customerUuid: data.customer_uuid,
      }));
  }
}

export const signUpService = new SignUpService();
